// ABOUTME: The order revenue panel: what a relation sold in a period, beside that revenue over time.
// ABOUTME: A relation session is scoped to its own orders by the API, so the panel takes no filter.

import { useTranslation } from "react-i18next";
import EuroIcon from '@mui/icons-material/Euro';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import ShoppingBagOutlinedIcon from '@mui/icons-material/ShoppingBagOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';

import ShTotalsPanel from "../../theme/cards/ShTotalsPanel";
import { useGetOrderRevenueDashboardChartQuery, useGetOrderRevenueDashboardTotalsQuery } from "../../../newapi/dashboard/dashboardSlice";

const OrderRevenueTotalsPanel = () => {
    const { t } = useTranslation();

    return (
        <ShTotalsPanel
            useTotals={useGetOrderRevenueDashboardTotalsQuery}
            useChart={useGetOrderRevenueDashboardChartQuery}
            chartSubtitles={{
                month: t("revenue_per_month"),
                week: t("revenue_per_week")
            }}
            chartSeries={[
                { type: "currency" },
                { type: "currency", chartType: "hidden" },
                { type: "number", chartType: "hidden" },
                { type: "number", chartType: "hidden" },
            ]}
            cards={[
                { key: "revenue", label: t("revenue"), icon: <EuroIcon className="logo"/>, color: "orange", type: "currency" },
                { key: "avgRevenue", label: t("avg_revenue"), icon: <TrendingUpIcon className="logo"/>, color: "purple", type: "currency" },
                { key: "orderCount", label: t("order_count"), icon: <ShoppingBagOutlinedIcon className="logo"/>, color: "blue", type: "number" },
                { key: "productCount", label: t("product_count"), icon: <Inventory2OutlinedIcon className="logo"/>, color: "green", type: "number" },
            ]}
        />
    );
};

export default OrderRevenueTotalsPanel;
